// src/components/AILoader.jsx
import { useEffect } from 'react';

export default function AILoader() {
  useEffect(() => {
    // Check if script already exists to avoid duplicates
    if (document.querySelector('script[src*="ai.apexforge.co.za/widget-loader.php"]')) {
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://ai.apexforge.co.za/widget-loader.php?client=hublu-2026';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Optional: clean up script and any widget DOM elements when leaving non-admin pages
      // However, this might remove it from cached pages; we leave it for simplicity
    };
  }, []);

  return null;
}